
import { Component, Vue } from 'vue-property-decorator';
import CurrentConsents from '~/components/User/Consents/PartnersConsents/CurrentConsents.vue';
import { UserModule } from '~/store/modules/user';
import { PopupModule } from '~common-store/modules/popup';

@Component({
    components: {
        CurrentConsents,
    },
})
export default class PartnersConsents extends Vue {
    showConsentsHistoryPopup() {
        PopupModule.setPopupRequested('marketing-consents-history');
    }

    unsubscribeUser() {
        UserModule.unsubscribeUserMarketingsConsents();
    }
}
